export const getChartColorsArray = (colorsArray: string[]): string[] => {
    return colorsArray.map((value: string) => {
      let newValue = value.replace(" ", "");
  
      // إذا اللون مش rgba
      if (newValue.indexOf(",") === -1) {
        let color = getComputedStyle(document.documentElement).getPropertyValue(
          newValue
        );
  
        if (color.indexOf("#") !== -1) color = color.replace(" ", "");
        if (color) return color;
        else return newValue;
      } else {
        // صيغة rgba(colorVar, opacity)
        let val = value.split(",");
        if (val.length === 2) {
          let rgbaColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  };